import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const timeRecords = createReducer({}, (builder) => {
  builder
    .addCase(actionTypes.ADD_TIME_RECORD_SUCCESS, (state, action) => {
      const { response = {}, id: customId } = action;
      const { result = {}, entities = {} } = response;
      const { single: id } = result;

      const { time_records = {} } = entities;
      const time_record = time_records[`${id}`];

      delete state[`${customId}`];

      if (time_record) {
        state[`${id}`] = time_record;
      }
    })
    .addCase(actionTypes.ADD_TIME_RECORD_ERROR, (state, action) => {
      const { id } = action;

      delete state[`${id}`];
    })
    .addCase(actionTypes.ADD_TIME_RECORD_LOADING, (state, action) => {
      const { id, attributes = {} } = action;
      state[`${id}`] = { ...attributes, id };
    })
    .addCase(actionTypes.DELETE_TIME_RECORD_ERROR, (state, action) => {
      const { timeRecordId } = action;
      state[`${timeRecordId}`] = {
        ...state[`${timeRecordId}`],
        is_trashed: false,
      };
    })
    .addCase(actionTypes.TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM, (state, action) => {
      const keys = Object.keys(state);
      const { response = {} } = action;
      const { result: id } = response;

      keys.forEach((key) => {
        if (state[`${key}`].parent_type !== "Task" || state[`${key}`].parent_id !== id) {
          return;
        }

        if (state[`${key}`].original_is_trashed) {
          state[`${key}`].original_is_trashed = false;
          return;
        }

        state[`${key}`].is_trashed = false;
        state[`${key}`].trashed_on = null;
      });
    })
    .addCase(actionTypes.PROJECT_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS, (state, action) => {
      const keys = Object.keys(state);
      const { response = {} } = action;
      const { result: id, entities = {} } = response;
      const { projects = {} } = entities;
      const { trashed_on } = projects[id] || {};

      keys.forEach((key) => {
        if (state[`${key}`].parent_type !== "Project" || state[`${key}`].parent_id !== id) {
          return;
        }

        if (state[`${key}`].is_trashed) {
          state[`${key}`].original_is_trashed = true;
          return;
        }

        state[`${key}`].is_trashed = true;
        state[`${key}`].trashed_on = trashed_on;
      });
    })
    .addCase(actionTypes.TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM, (state, action) => {
      const keys = Object.keys(state);
      const { response = {} } = action;
      const { result: id, entities = {} } = response;
      const { tasks = {} } = entities;
      const { trashed_on } = tasks[id] || {};

      keys.forEach((key) => {
        if (state[`${key}`].parent_type !== "Task" || state[`${key}`].parent_id !== id) {
          return;
        }

        if (state[`${key}`].is_trashed) {
          state[`${key}`].original_is_trashed = true;
          return;
        }

        state[`${key}`].is_trashed = true;
        state[`${key}`].trashed_on = trashed_on;
      });
    })
    .addCase(actionTypes.FETCH_PROJECT_LIST_TIME_RECORDS_SUCCESS, (state, action) => {
      const { response = {}, cursor } = action;
      const { entities = {} } = response;
      const { time_records = {} } = entities;
      if (!cursor) {
        return { ...time_records };
      }
      return { ...state, ...time_records };
    })
    .addMatcher(
      (action) =>
        [
          actionTypes.FETCH_TIMESHEET_TIME_RECORDS_SUCCESS,
          actionTypes.FETCH_PROJECT_TIME_RECORDS_BY_DATES_SUCCESS,
          actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS,
          actionTypes.UPDATED_TIME_RECORDS,
          actionTypes.FETCH_TIME_RECORDS_SUCCESS,
          actionTypes.BATCH_EDIT_TIME_RECORDS_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { time_records = {} } = entities;

        return { ...state, ...time_records };
      }
    )
    .addMatcher(
      (action) =>
        [
          actionTypes.TIME_RECORD_CREATED_FROM_EVENT_STREAM,
          actionTypes.TIME_RECORD_UPDATED_FROM_EVENT_STREAM,
          actionTypes.TIME_RECORD_MOVED_TO_PROJECT_FROM_EVENT_STREAM,
          actionTypes.TIME_RECORD_MOVE_TO_TRASH_FROM_EVENT_STREAM,
          actionTypes.TIME_RECORD_RESTORED_FROM_TRASH_FROM_EVENT_STREAM,
          actionTypes.DELETE_TIME_RECORD_SUCCESS,
          actionTypes.DELETE_TIME_RECORD_LOADING,
          actionTypes.EDIT_TIME_RECORD_SUCCESS,
          actionTypes.MOVE_TIME_RECORD_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { result = {}, entities = {} } = response;
        const { single: id } = result;
        const { time_records = {} } = entities;

        if (time_records[id]) {
          state[`${id}`] = time_records[`${id}`];
        }
        return state;
      }
    )
    .addMatcher(
      (action) => [actionTypes.EDIT_PROJECT_FROM_EVENT_STREAM_SUCCESS].includes(action.type),
      (state, action) => {
        const keys = Object.keys(state);
        const { response = {} } = action;
        const { result: projectId, entities = {} } = response;
        const { projects = {} } = entities;

        const isTimeTrackingEnabled = projects[projectId].is_tracking_enabled;

        if (projectId && !isTimeTrackingEnabled) {
          keys.forEach((key) => {
            if (state[`${key}`].project_id === projectId) {
              delete state[`${key}`];
            }
          });
          return state;
        }
      }
    );
});

export default timeRecords;
